<template>
  <div class="modal-popup">
    <div class="modal fade" id="remotePaymentStart" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" v-if="booking != null">
          <div class="modal-header">
            <h3 class="title mt-2 ml-2">Uzaktan Ödeme</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post">
                <div class="row">
                  <div class="col-sm-6" v-if="projectName !== 'selectum'">
                    <div class="input-box">
                      <label class="label-text">Tutar</label>
                      <input class="form-control" v-model="remotePayment.paymentAmount" id="paymentAmount" type="number" placeholder="">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="input-box" v-if="paymentUrl">
                      <label class="label-text">Payment Url</label>
                      <button @click="copyToClipboard(paymentUrl)" class="label-text text-color-7" type="button">Adresi Kopyala</button>
                      <input disabled class="form-control" v-model="paymentUrl" id="paymentUrl" type="text" placeholder="">
                    </div>
                    <div class="input-box d-flex align-items-center" v-if="projectName !== 'selectum'">
                      <label class="label-text">Non Secure</label>
                      <input class="form-control " style="width: 5rem;" type="checkbox" v-model="remotePayment.nonSecure">
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">Cancel</button>
            <button @click="accept" type="button" class="theme-btn theme-btn-small">Onaylıyorum</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messagePopupManager from "../../util/messagePopupManager";

export default {
  name: "RemotePaymentPopup",
  data:function (){
    return{
      remotePayment: {},
      paymentUrl : null
    }
  },
  computed:{
    agencyList:{
      get(){
        return this.$store.getters.getAgencyList
      }
    },
    booking:{
      get(){
        return this.$store.getters.getBooking
      }
    },
    projectName:{
      get() {
        return this.$store.getters.getProjectName;
      }
    }
  },
  methods:{
    copyToClipboard(txt) {
      var x = document.getElementById("snackbar");

      $(document.getElementById("snackbar")).html("Ödeme adresi kopyalandı")
      // Add the "show" class to DIV
      x.className = "show";

      // After 3 seconds, remove the show class from DIV
      setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
        var m = document;
        txt = m.createTextNode(txt);
        var w = window;
        var b = m.body;
        b.appendChild(txt);
        if (b.createTextRange) {
          var d = b.createTextRange();
          d.moveToElementText(txt);
          d.select();
          m.execCommand('copy');
        }
        else {
          var d = m.createRange();
          var g = w.getSelection;
          d.selectNodeContents(txt);
          g().removeAllRanges();
          g().addRange(d);
          m.execCommand('copy');
          g().removeAllRanges();
        }
        txt.remove();
    },
    accept(){
      if(this.projectName === 'selectum'){
        this.paymentUrl = 'https://selectumblucruises.com/booking/payment?bref='+this.booking.ref;
      }
      if(this.remotePayment.paymentAmount != null){
        this.remotePayment.bookingId = this.booking.id
        this.$store.dispatch("remotePayment",this.remotePayment).then(response => {
          this.paymentUrl = response.data.paymentUrl;
        }).catch(error => {
          messagePopupManager.showError("Hata", error.response.data.message);
        })
      }else{
        $("#selectedAgency").addClass("error");
        $("#paymentAmount").addClass("error");
      }

    }
  },
  updated() {
    setTimeout(function () {
      $(".select-contain-select").selectpicker('refresh');
    }, 100);
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  }
}
</script>

<style scoped>

</style>